<ion-header class="ion-no-border border-bottom-cloudotdr">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button color="primary" />
    </ion-buttons>
    <ion-title class="ion-text-left">
      <div class="pageTitle">{{ this.pageTitle() }}</div>
      <div class="deploymentName">{{ this.subTitle() ?? this.deploymentStore.selectedDeployment()?.name }}</div>
    </ion-title>
    <div slot="start">
      @if (this.notificationStore.signalRConnectionState() === 1) {
        <ion-icon color="warning" name="wifi-outline" />
      } @else if (this.notificationStore.signalRConnectionState() === 2) {
        <ion-icon color="success" name="wifi-outline" />
      } @else {
        <ion-icon color="danger" name="wifi-outline" />
      }
    </div>

    <ion-buttons slot="end">
      <ng-container *ngTemplateOutlet="customActionsTemplate()" />
    </ion-buttons>
  </ion-toolbar>
</ion-header>
